import { useTranslation } from "react-i18next";

import { IconPlus } from "@pentabd/icons";
import { Button } from "@pentabd/ui";

interface ActionButtonPropTypes {
  label: string;
  clickAction: any;
  disabled?: boolean;
}

export const AddMoreButton = ({
  label,
  clickAction,
  disabled,
}: ActionButtonPropTypes) => {
  const { t } = useTranslation();

  return (
    <Button
      htmlType="button"
      type="light"
      fill="outline"
      onClick={clickAction}
      size="sm"
      className="w-max"
      disabled={disabled}
    >
      <IconPlus size="20" fill="dark" />
      {t(label)}
    </Button>
  );
};
